import { useMutation } from "@tanstack/react-query";
import { useFormContext } from "react-hook-form";

import ControlledForm from "../components/form/controlled-form.tsx";
import ControlledInput from "../components/form/controlled-input.tsx";
import ControlledPassword from "../components/form/controlled-password.tsx";
import { Button } from "../components/ui/button.tsx";
import { LoginFormData, loginSchema } from "../schemas/login.schema.ts";
import useUserStore from "../stores/user.store.ts";
import { setSessionToken } from "../api/token-helper.ts";
import { api } from "../api/custom-api.ts";
import { Toaster, toaster } from "../components/ui/toaster.tsx";

export const Login = () => {
  const {
    handleSubmit,
    formState: { isValid },
  } = useFormContext<LoginFormData>();
  const { setUser } = useUserStore();

  const { mutate, isLoading } = useMutation({
    mutationFn: (request: { email: string; password: string }) =>
      api.auth.loginWarehouse(request),
    onSuccess: async (response) => {
      setSessionToken(response.sessionToken);
      const { id, email, type } = await api.auth.getAuthWhoAmI();
      setUser({ id, email, type });
    },
    onError: () => {
      toaster.create({
        title: "Greška!",
        description: "Uneta email adresa ili šifra nije važeća",
        type: "error",
        duration: 5000,
      });
    },
  });

  const onSubmit = handleSubmit((data) => {
    mutate({ email: data.email, password: data.password });
  });

  return (
    <>
      <div className="w-full h-screen flex flex-col items-center justify-center bg-gray-100">
        {/* Logo/Header Section */}
        <div className="w-full bg-white p-6 shadow-md flex justify-center">
          <img src="/assets/radic.webp" alt="Logo" className="w-40 h-16" />
        </div>

        {/* Login Form Section */}
        <div className="w-full max-w-md mt-12 bg-white p-8 rounded-lg shadow-md">
          <h1 className="font-bold text-2xl text-center text-black">
            Uloguj se
          </h1>
          <form className="w-full mt-6 space-y-6" onSubmit={onSubmit}>
            <div className="space-y-4">
              <ControlledInput
                name="email"
                label="Email adresa"
                placeholder="Unesi email adresu"
                className={"w-full"}
              />
              <ControlledPassword
                label="Šifra"
                name="password"
                placeholder="Unesi šifru"
                className={"w-full"}
              />
            </div>
            <div>
              <Button
                size="sm"
                type="submit"
                variant="surface"
                color="#000000"
                width="full"
                backgroundColor="#ffffff"
                borderColor="#e5e7eb"
                fontWeight="600"
                fontSize="14px"
                loading={isLoading}
                borderRadius="0.5rem"
                disabled={!isValid}
              >
                Potvrdi
              </Button>
            </div>
          </form>
        </div>
      </div>
      <Toaster />
    </>
  );
};

export const LoginPage = () => {
  return (
    <ControlledForm schema={loginSchema}>
      <Login />
    </ControlledForm>
  );
};
